export const TOAST_VISIBLE_DURATION_MS: number = 2600;

interface ScheduleToastDismissParams {
  message: string;
  onDismiss: () => void;
}

export function scheduleToastDismiss({
  message,
  onDismiss,
}: ScheduleToastDismissParams): () => void {
  if (!message) return (): void => {};
  const timeoutId: ReturnType<typeof setTimeout> = setTimeout(onDismiss, TOAST_VISIBLE_DURATION_MS);
  return (): void => {
    clearTimeout(timeoutId);
  };
}
